import React, { createContext, useReducer } from "react";
import { roomsReducer, roomsInitialState, RoomsState, RoomsAction } from '../reducers/rooms-reducer'
interface Props {
    roomsState: RoomsState,
    roomsDispatch: React.Dispatch<RoomsAction>
}
export const RoomsContext = createContext<Props>({ roomsState: roomsInitialState, roomsDispatch: () => { } })

const RoomsContextProvider: React.FC = (props) => {
    const [state, dispatch] = useReducer(roomsReducer, roomsInitialState)

    return (
        <RoomsContext.Provider value={{ roomsState: state, roomsDispatch: dispatch }}>
            {props.children}
        </RoomsContext.Provider>
    )
}

export default RoomsContextProvider